"use client";

import { useEffect } from "react";

export default function ErrorBoundary({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center">
      <div className="text-6xl">⚠️</div>
      <h1 className="text-2xl font-semibold mt-4">Something went wrong</h1>
      <p className="text-neutral-500 mt-2 text-sm">
        {error.message || "An unexpected error occurred."}
      </p>
      <button
        onClick={reset}
        className="mt-6 bg-rose-600 hover:bg-rose-700 text-white rounded-lg px-5 py-2.5 text-sm font-medium"
      >
        Try again
      </button>
    </div>
  );
}
